import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';
import {RenderHTML} from '@learningblocks/storybook-components';
import './style.scss';

/**
 * Content to be displayed inside FullWidthCard - ModalWindow
 */
export function CardModalContent(props) {
  const renderContentByType = (component, key) => {
    switch (component.type) {
      case COMPONENT_TYPE.FULL_WIDTH_IMAGE:
        return (
          <Image
            key={key}
            src={component.image}
            alt={component.image}
            width='100%'
          />
        );
      case COMPONENT_TYPE.PLAIN_TEXT:
      case COMPONENT_TYPE.SUB_HEADING:
        return <RenderHTML key={key} content={component.text} />;
      default:
        return null;
    }
  };

  return (
    <div className='technique-description'>
      {props.components.map(renderContentByType)}
    </div>
  );
}

CardModalContent.propTypes = {
  /**
   * List of components to be displayed inside Card - Modal Window
   */
  components: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['FULL_WIDTH_IMAGE', 'PLAIN_TEXT', 'SUB_HEADING']),
      image: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

CardModalContent.defaultProps = {
  components: [],
};
